export default __webpack_public_path__ + "static/media/template.d512f119.svg";